import React from 'react';
import HeroSection from '../../components/shared/HeroSection';
import TrainingOfferings from './sections/TrainingOfferings';
import TrainingApproach from './sections/TrainingApproach';
import SchedulingContact from './sections/SchedulingContact';
import Footer from '../../components/shared/Footer';

const Trainings = () => {
  return (
    <div>
      {/* Hero Section */}
      <HeroSection 
        backgroundImage="/assets/asset-10.jpg"
        title="Professional Training"
      />

      {/* Training Offerings */}
      <TrainingOfferings />

      {/* Training Approach */}
      <TrainingApproach />

      {/* Scheduling/Contact */}
      <SchedulingContact />

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Trainings;